/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateSupplementJustificationsRequestJustificationsInner } from './UpdateSupplementJustificationsRequestJustificationsInner';
import {
    UpdateSupplementJustificationsRequestJustificationsInnerFromJSON,
    UpdateSupplementJustificationsRequestJustificationsInnerFromJSONTyped,
    UpdateSupplementJustificationsRequestJustificationsInnerToJSON,
    UpdateSupplementJustificationsRequestJustificationsInnerToJSONTyped,
} from './UpdateSupplementJustificationsRequestJustificationsInner';

/**
 * Payload to update texts for multiple supplement justifications
 * @export
 * @interface UpdateSupplementJustificationsRequest
 */
export interface UpdateSupplementJustificationsRequest {
    /**
     * 
     * @type {Array<UpdateSupplementJustificationsRequestJustificationsInner>}
     * @memberof UpdateSupplementJustificationsRequest
     */
    justifications: Array<UpdateSupplementJustificationsRequestJustificationsInner>;
}

/**
 * Check if a given object implements the UpdateSupplementJustificationsRequest interface.
 */
export function instanceOfUpdateSupplementJustificationsRequest(value: object): value is UpdateSupplementJustificationsRequest {
    if (!('justifications' in value) || value['justifications'] === undefined) return false;
    return true;
}

export function UpdateSupplementJustificationsRequestFromJSON(json: any): UpdateSupplementJustificationsRequest {
    return UpdateSupplementJustificationsRequestFromJSONTyped(json, false);
}

export function UpdateSupplementJustificationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupplementJustificationsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'justifications': ((json['justifications'] as Array<any>).map(UpdateSupplementJustificationsRequestJustificationsInnerFromJSON)),
    };
}

export function UpdateSupplementJustificationsRequestToJSON(json: any): UpdateSupplementJustificationsRequest {
    return UpdateSupplementJustificationsRequestToJSONTyped(json, false);
}

export function UpdateSupplementJustificationsRequestToJSONTyped(value?: UpdateSupplementJustificationsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'justifications': ((value['justifications'] as Array<any>).map(UpdateSupplementJustificationsRequestJustificationsInnerToJSON)),
    };
}

